import axios from 'axios'
import tools from '../common/tools'
import vue from '../main'

// 前台网站地址
let webUrl
// 接口请求地址
let baseUrl

let localeLang = 'zh'
if(localStorage.langType) {
    localeLang = localStorage.langType
}

if(window.location.port == 8080) {
    // 本地
    webUrl = 'http://www.idcmaster.local' + '/' + localeLang
    baseUrl = 'http://www.idcmaster.local' + '/' + localeLang + '/user'
} else {
    // 线上
    webUrl = window.location.origin + '/' + localeLang
    baseUrl = window.location.origin + '/' + localeLang + '/user'
}

// axios设置
axios.defaults.baseURL = baseUrl
axios.defaults.headers.post['Content-Type'] = 'application/json'
axios.defaults.timeout = 50000


// 添加请求拦截器
axios.interceptors.request.use(function (config) {
    // 在发送请求之前添加token头部
    // if(tools.getCookie("token")) {
    //     config.headers['token'] = tools.getCookie("token")
    // }
    return config
}, function (error) {
    // 对请求错误做些什么
    return Promise.reject(error)
})

// 添加响应拦截器
axios.interceptors.response.use(function (response) {
    // 判断token是否过期 
    if(response.data.status == 202) {
		location.href = `${webUrl}/login.html?from=${location.href}`
    }
    return response
}, function (error) {
    // 对响应错误做点什么
    return Promise.reject(error)
})


/**将对象转换为url参数形式（用于嵌套数据）
 * @property {Object} param 将要转换为URL参数的字符串对象
 * @property {String} key URL 参数字符串的前缀
 * @property {Boolean} encode 是否进行URL编码，默认为true
 * @return {String} URL参数字符串
 */
const urlEncode = function(param, key, encode) {
    if (param == null) return ''
    var paramStr = ''
    var t = typeof(param)
    if (t == 'string' || t == 'number' || t == 'boolean') {
        paramStr += '&' + key + '=' + ((encode == null || encode) ? encodeURIComponent(param) : param)
    } else {
        for (var i in param) {
            var k = key == null ? i: key + (param instanceof Array ? '[' + i + ']': '[' + i + ']')
            paramStr += urlEncode(param[i], k, encode)
        }
    }
    return paramStr
}


// 请求判断版本更新
const isNewVersion = async () => {
    let url = `//${window.location.host}/version.json?t=${new Date().getTime()}`
    let res = await axios.get(url)
    if(res.status === 200) {
        let vueVersion = res.data.version
        let localVueVersion = localStorage.getItem('vueVersion')
        let sessionVueVersion = sessionStorage.getItem('sVueVersion')
        if(sessionVueVersion == null) {
            sessionStorage.setItem('sVueVersion',vueVersion)
            sessionVueVersion = vueVersion
        }
        if(localVueVersion != vueVersion || sessionVueVersion != vueVersion) {
            localStorage.setItem('vueVersion',vueVersion)
            sessionStorage.setItem('sVueVersion',vueVersion)
            window.history.go(0)
        }
    }
}

/** 获取公共信息
 *  */
const siteInfo = params => axios.get('/site/info',{params})

/** 退出登录
 *  */
const logout = params => axios.get('/logout',{params})

/** 用户首页数据统计
 *  */
const userStatistics = params => axios.get('/user/statistics',{params})

/** 域名管理列表
 * @limit 本页条数
 * @page 页码数
 * @domain 域名
 * @create_time 注册时间
 * @expire_time 到期时间
 * @status 状态:1=正常,0=到期,-1=已删除,2=HOLD
 *  */
const userDomainIndex = params => axios.get('/domain/list',{params})

/** 域名详情
 * @domain 域名
 *  */
const domainInfo = domain => axios.get('/domain/info/'+domain,'')

/** 域名续费
 * @domain 域名
 * @years 续费年数:1-10年
 * @payment_id 支付方式id
 *  */
const userDomainRenewal = params => axios.post('/domain/renewal',params)

/** DNS解析记录列表
 * @domain 域名
 *  */
const userDomainDnsListRecords = domain => axios.get('/domain/records/'+domain,'')

/** 添加DNS解析记录
 * @domain 域名
 * @rrtype 要添加的资源记录的类型。 可能的值为“A”、“AAAA”、“CNAME”、“MX”、“TXT”和“SRV”
 * @rrhost 新记录的主机名（无需包含“.DOMAIN”）
 * @rrvalue 资源记录的值
 * @rrdistance 仅用于 MX（如果未提供，则默认为 10）
 * @rrttl 新记录的 TTL（如果未提供，则默认为 7207）
 *  */
const userDomainDnsAddRecord = params => axios.post('/domain/records/add',params)

/** 修改DNS解析记录
 * @rrid 记录id
 * @domain 域名
 * @rrtype 要添加的资源记录的类型。 可能的值为“A”、“AAAA”、“CNAME”、“MX”、“TXT”和“SRV”
 * @rrhost 新记录的主机名（无需包含“.DOMAIN”）
 * @rrvalue 资源记录的值
 * @rrdistance 仅用于 MX（如果未提供，则默认为 10）
 * @rrttl 新记录的 TTL（如果未提供，则默认为 7207）
 *  */
const userDomainDnsUpdateRecord = params => axios.post('/domain/records/edit',params)

/** 删除DNS解析记录
 * @domain 域名
 * @rrid 记录id
 *  */
const userDomainDnsDeleteRecord = params => axios.post('/domain/records/delete',params)

/** 获取账户信息
 *  */
const userUserInfo = params => axios.get('/user/info',{params})

/** 修改账户信息
 *  */
const userInfoSave = params => axios.post('/user/info/save',params)

/** 修改密码
 * @password 原密码
 * @newpassword 新密码
 * @repassword 重复新密码
 *  */
const userPasswordReset = params => axios.post('/user/password/reset',params)

/** 获取登录日志
 *  */
const userUserLoginLog = params => axios.get('/user/log',{params})

/** 添加子域名转发
 * @domain 域名
 * @sub_domain 您要转发的子域
 * @protocol URL协议(可选:http/https)
 * @address 要转发到的网站地址
 * @method 要使用的转发方法（选项为“301”、“302”或“cloaked”）
 * @meta_title META 标题（可选（仅在选择“cloaked”作为方法并且所有值都必须进行编码时使用）
 * @meta_description META 描述（可选（仅在选择“cloaked”作为方法并且所有值都必须进行编码时使用）
 * @meta_keywords 转发的 META 关键字（可选（仅在选择“cloaked”作为方法并且所有值都必须进行编码时使用）
 *  */
const userDomainSubDomainForward = params => axios.post('/domain/forward/subDomainAdd',params)

/** 添加主域名转发
 * @domain 域名
 * @protocol URL协议(可选:http/https)
 * @address 要转发到的网站地址
 * @method 要使用的转发方法（选项为“301”、“302”或“cloaked”）
 * @meta_title META 标题（可选（仅在选择“cloaked”作为方法并且所有值都必须进行编码时使用）
 * @meta_description META 描述（可选（仅在选择“cloaked”作为方法并且所有值都必须进行编码时使用）
 * @meta_keywords 转发的 META 关键字（可选（仅在选择“cloaked”作为方法并且所有值都必须进行编码时使用）
 *  */
const domainForwardAdd = params => axios.post('/domain/forward/add',params)

/** 获取dns服务器列表
 * @domain 域名
 *  */
const domainDnsList = domain => axios.get('/domain/dns/list/'+domain,'')

/** 修改dns服务器列表
 * @domain 域名
 * @sub_domain 转发的子域
 *  */
const domainDnsChange = params => axios.post('/domain/dns/change',params)

/** 获取子域名转发列表
 * @domain 域名
 *  */
const domainForwardSubDomainList = domain => axios.get('/domain/forward/subDomainList/'+domain,'')

/** 删除子域名转发
 * @domain 域名
 * @sub_domain 转发的子域
 *  */
const domainForwardDeleteSubDomain = params => axios.post('/domain/forward/deleteSubDomain',params)

/** 获取域名联系人模板
 * @keywords 关键字搜索
 * @email 邮箱搜索
 * @phone 电话搜索
 * @status 状态
 *  */
const domainTemplateList = params => axios.get('/domain/template/list',{params})

/** 新建联系人模板
 * @name 模板名称
 * @first_name 名字
 * @last_name 姓名
 * @address 联系地址
 * @city 城市
 * @region 省份地区
 * @zip_code 邮编
 * @country 国家:参照国家编码
 * @email 邮箱
 * @phone 电话
 * @company 公司名称
 * @status 状态:1=使用,0=禁用
 *  */
const domainTemplateAdd = params => axios.post('/domain/template/add',params)

/** 获取域名联系人模板详情
 * @id id
 *  */
const domainTemplateDetails = params => axios.get('/domain/template/details',{params})

/** 修改联系人模板
 * @name 模板名称
 * @first_name 名字
 * @last_name 姓名
 * @address 联系地址
 * @city 城市
 * @region 省份地区
 * @zip_code 邮编
 * @country 国家:参照国家编码
 * @email 邮箱
 * @phone 电话
 * @company 公司名称
 * @status 状态:1=使用,0=禁用
 *  */
const domainTemplateEdit = (id,params) => axios.post('/domain/template/edit?id='+id,params)

/** 删除域名联系人模板
 * @id id
 *  */
const domainTemplateDelete = params => axios.post('/domain/template/delete',params)

/** 获取余额使用明细
 * @description 消费描述
 * @order_type 订单类型:1=域名,2=SSL证书,3=物理机,4=云服务器,5=CDN,6=增值服务,7=VPN专线,8=充值,9=扣款,10=其他产品
 * @start_time 开始时间 格式2020-05-02
 * @end_time 按时间区间查询
 *  */
const userFinancialChanges = params => axios.get('/financial/change',{params})

/** 获取订单支付方式列表
 *  */
const paymentGetPaymentList = params => axios.get('/pay/payment/order',{params})

/** 获取余额充值支付方式列表
 *  */
const payPaymentRecharge = params => axios.get('/pay/payment/recharge',{params})

/** 物理服务器订单列表
 * @order_id 订单号
 * @product_name 产品名称
 * @status 订单状态:0=未生效,1=已生效,2=已取消,-1=已退款
 * @pay_status 支付状态:0=未支付,1=已支付,-1=已退款
 * @type 订单类型:1=新开,2=续费
 *  */
const userOrderServerList = params => axios.get('/order/server/list',{params})

/** 物理服务器订单详情
 *  */
const orderServerDetails = params => axios.get('/order/server/details',{params})

/** 云服务器订单列表
 *  */
const orderCloudList = params => axios.get('/order/cloud/list',{params})

/** 云服务器订单详情
 *  */
const orderCloudDetails = params => axios.get('/order/cloud/details',{params})

/** 域名订单列表
 * @suffix 后缀
 * @order_id 订单编号
 * @type 
 *  */
const DomainOrderList = params => axios.get('order/domain/list',{params})

/** 域名订单详情
 *  */
const orderDomainDetails = params => axios.get('/order/domain/details',{params})

/** 账户充值
 * @amount 充值的金额
 * @payment_method 付款方式
 *  */
const userPaymentRecharge = params => axios.post('/order/pay/recharge',params)

/** 物理服务器列表
 * @start_time 开始时间
 * @expire_time 结束时间
 * @status 状态
 * @name 产品名称
 *  */
const userServerLists = params => axios.get('/server/list',{params})

/** 物理服务器详情
 * @id id
 *  */
const serverDetail = params => axios.get('/server/details',{params})

/** 获取流量图
 * @id 服务器id
 * @start 开始时间
 * @end 结束时间
 *  */
const serverTraffic = params => axios.post('/server/traffic',params)

/** 服务器电源操作
 * @id 服务器id
 * @action start/stop/reset
 *  */
const serverPower = params => axios.post('/server/power',params)

/** 获取重装系统列表
 * @id 服务器id
 *  */
const serverOslist = params => axios.get('/server/oslist',{params})

/** 服务器续费
 * @id 服务器id
 *  */
const serverRenewal = params => axios.post('/server/renewal',params)

/** 重装系统
 *  */
const serverRebuild = params => axios.post('/server/rebuild',params)

/** 获取重装系统任务进度
 * @id 服务器id
 *  */
const serverTask = params => axios.post('/server/task',params)

/** 取消重装系统
 * @id 服务器id
 *  */
const serverCancelRebuild = params => axios.post('/server/cancelRebuild',params)

/** 服务器重置密码
 * @id 服务器id
 * @password 新密码
 *  */
const serverPassword_reset = params => axios.post('/server/passwordReset',params)

/** 修改服务器备注
 * @id 服务器id
 * @remarks 备注
 *  */
const serverEdit = params => axios.post('/server/note',params)

/** 计算退款金额
 * @product_type 产品类型:server=服务器,domian=域名,ssl=SSL证书,cdn=CDN,vps=VPS
 * @business_id 资源ID
 *  */
const refundCalculate = params => axios.post('/refund/calculate',params)

/** 申请退款
 * @product_type 产品类型:server=服务器,domian=域名,ssl=SSL证书,cdn=CDN,vps=VPS
 * @business_id 资源ID
 * @refund_reason 退款原因
 *  */
const refundApply = params => axios.post('/refund/apply',params)

/** ssl证书退款
 *  */
const sslSslRefund = params => axios.post('/ssl/ssl/refund',params)

/** 取消退款
 * @id id
 *  */
const refundCancel = params => axios.post('/refund/cancel',params)

/** 退款列表
 *  */
const refundList = params => axios.get('/refund/list',{params})

/** 退款详情
 * @id id
 *  */
const refundGet = params => axios.get('/refund/details',{params})

/** 账单列表
 *  */
const payOrderList = params => axios.get('/order/pay/list',{params})

/** 账单详情
 * @id id
 *  */
const payOrderGet = params => axios.get('/order/pay/details',{params})

/** 账单再次发起支付
 * @id id
 * @payment_id 支付方式id
 *  */
const payOrderPayAgain = params => axios.post('/order/pay/repay',params)

/** ssl证书列表
 *  */
const SSLList = params => axios.get('/ssl/ssl/list',{params})

/** ssl证书模板列表
 *  */
const SSLTemplateList = params => axios.get('ssl/template/list',{params})

/** ssl证书详情
 *  */
const SSLSslGet = params => axios.get('ssl/ssl/details',{params})

/** ssl证书模板删除
 * @ids []
 *  */
const SSLTemplateDel = params => axios.post('ssl/template/delete',params)

/** ssl证书模板获取详情
 * @id id
 *  */
const SSLTemplateGet = params => axios.get('ssl/template/details',{params})

/** ssl证书模板新建
 *  */
const SSLTemplateAdd = params => axios.post('ssl/template/add',params)

/** ssl证书模板编辑
 *  */
const SSLTemplateEdit = params => axios.post('ssl/template/edit',params)

/** ssl证书申请
 *  */
const SSLSslApply = params => axios.post('ssl/ssl/apply',params)

/** ssl证书订单列表
 * @order_id 订单号
 * @product_title
 * @pay_status 支付状态:0=未支付,1=已支付,-1=已退款
 *  */
const SSLOrderList = params => axios.get('order/ssl/list',{params})

/** ssl订单详情
 *  */
const orderSslDetails = params => axios.get('/order/ssl/details',{params})

/** 查询订单是否支付成功
 *  */
const PayOrderCheck = params => axios.post('/order/pay/check',params)

/** 获取工单列表
 *  */
const ticketList = params => axios.get('/ticket/list',{params})

/** 关闭工单
 *  */
const ticketClose = params => axios.post('/ticket/close',params)

/** 提交工单
 *  */
const ticketAdd = params => axios.post('/ticket/add',params)

/** 工单详情
 *  */
const ticketDetails = params => axios.get('/ticket/details',{params})

/** 回复工单
 *  */
const ticketReply = params => axios.post('/ticket/reply',params)

/** 余额明细详情
 *  */
const financialChangesDetails = params => axios.get('/financial/changes/details',{params})

/** 获取推广数据
 *  */
const affDetails = params => axios.post('/aff/details',params)

/** 获取推广订单列表
 *  */
const affOrder = params => axios.get('/aff/order',{params})

/** 获取推广提现记录列表
 *  */
const affWithdrawCommissionList = params => axios.get('/aff/withdrawCommission/list',{params})

/** 获取推广用户列表
 *  */
const affUserList = params => axios.get('/aff/user/list',{params})

/** 推广申请提现
 *  */
const affWithdraw = params => axios.post('/aff/withdraw',params)

/** 申请推广链接
 *  */
const affCreateInviteCode = params => axios.post('/aff/createInviteCode',params)

/** 获取云服务器列表
 *  */
const cloudList = params => axios.get('/cloud/list',{params})

/** 云服务器修改备注
 *  */
const cloudNote = params => axios.post('/cloud/note',params)

/** 云服务器续费
 *  */
const cloudRenewal = params => axios.post('/cloud/renewal',params)

/** 获取云服务器详情
 *  */
const cloudDetails = params => axios.get('/cloud/server/info',{params})

/** 云服务器开关机/重启/强制关机/强制重启
 *  */
const cloudPower = params => axios.post('/cloud/power',params)

/** 云服务器重置密码
 *  */
const cloudResetPwd = params => axios.post('/cloud/reset/pwd',params)

/** 获取云服务器控制台
 *  */
const cloudServerVnc = params => axios.get('/cloud/server/vnc',{params})

/** 云服务器重装系统
 *  */
const cloudRebuild = params => axios.post('/cloud/rebuild',params)

/** 云服务器开启系统救援
 *  */
const cloudSystemStartRescue = params => axios.post('/cloud/system/start/rescue',params)

/** 云服务器退出系统救援
 *  */
const cloudSystemStopRescue = params => axios.get('/cloud/system/stop/rescue',{params})

/** 云服务器获取镜像列表
 *  */
const cloudOsList = params => axios.get('/cloud/os/list',{params})

/** 获取云服务器状态
 *  */
const cloudServerStatus = params => axios.get('/cloud/server/status',{params})

/** 获取云服务器图表数据
 *  */
const cloudStatistics = params => axios.post('/cloud/statistics',params)

/** 获取云服务器流量统计
 *  */
const cloudFlow_data = params => axios.get('/cloud/flow_data',{params})

/** 获取云服务器安全组规则列表
 *  */
const cloudSecurity_groups_rule_list = params => axios.get('/cloud/security_groups_rule_list',{params})

/** 获取云服务器安全组规则协议
 *  */
const cloudSecurity_group_rule_protocols = params => axios.get('/cloud/security_group_rule_protocols',{params})

/** 云服务器新增安全组规则
 *  */
const cloudCreate_security_groups_rule = params => axios.post('/cloud/create_security_groups_rule',params)

/** 云服务器删除安全组规则
 *  */
const cloudDel_security_groups_rule = params => axios.post('/cloud/del_security_groups_rule',params)

/** 获取云服务器定时任务列表
 *  */
const cloudGet_cron_snap_list = params => axios.get('/cloud/get_cron_snap_list',{params})

/** 云服务器添加定时任务
 *  */
const cloudAdd_cron_snap = params => axios.post('/cloud/add_cron_snap',params)

/** 云服务器删除定时任务
 *  */
const cloudDel_cron_snap = params => axios.post('/cloud/del_cron_snap',params)

/** 云服务器修改主机名
 *  */
const cloudHostname = params => axios.post('/cloud/hostname',params)

/** 云服务器退款金额计算
 *  */
const cloudCalculate = params => axios.get('/cloud/calculate',{params})

/** 云服务器退款申请
 *  */
const cloudRefund = params => axios.post('/cloud/refund',params)

/** 通知设置
 *  */
const userSettingNotification = params => axios.post('/user/settingNotification',params)

/** 谷歌验证绑定二维码
 *  */
const userGet_bind_goole_qr_code = params => axios.get('/user/get_bind_goole_qr_code',{params})

/** 谷歌验证绑定
 *  */
const userBind = params => axios.post('/user/bind',params)

/** 用户操作发送邮箱验证码
 *  */
const userSend_email = params => axios.get('/user/send_email',{params})

/** 谷歌验证
 *  */
const userVerify_code = params => axios.post('/user/verify_code',params)

/** 用户操作邮箱验证
 *  */
const userEmail_verify_code = params => axios.post('/user/email_verify_code',params)

/** 云服务器查询敏感信息
 *  */
const userCloudGet_filed = params => axios.post('/cloud/get_filed',params)

/** 服务器查询敏感信息
 *  */
const serverSensitiveInfo = params => axios.get('/server/sensitive/info',{params})

/** 物理机计算退款金额
 *  */
const serverCalculate = params => axios.post('/server/calculate',params)

/** 物理机申请退款
 *  */
const serverRefund = params => axios.post('/server/refund',params)

/** 域名计算退款金额
 *  */
const domainCalculate = params => axios.get('/domain/calculate',{params})

/** 域名申请退款
 *  */
const domainRefund = params => axios.post('/domain/refund',params)

/** 图片上传
 *  */
const ticketUploadImages = params => axios.post('/ticket/upload/images',params,{
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    }
)

/** 优惠卷列表
 *  */
const userCouponList = params => axios.get('/coupon/list',{params})

/** 解除谷歌验证绑定
 *  */
const userClear_google_secret = params => axios.get('/user/clear_google_secret',{params})

/** VPS列表
 *  */
const vpsList = params => axios.get('/vps/list',{params})

/** VPS修改备注信息
 *  */
const vpsNote = params => axios.post('/vps/note',params)

/** VPS详情
 *  */
const vpsDetails = params => axios.get('/vps/details',{params})

/** VPS流量图
 *  */
const vpsTraffic = params => axios.post('/vps/traffic',params)

/** VPS电源操作
 *  */
const vpsPower = params => axios.post('/vps/power',params)

/** 获取vps敏感信息
 *  */
const vpsSensitiveInfo = params => axios.get('/vps/sensitive/info',{params})

/** 获取vps操作系统
 *  */
const vpsOslist = params => axios.get('/vps/oslist',{params})

/** VPS续费
 *  */
const vpsRenewal = params => axios.post('/vps/renewal',params)

/** VPS计算退款金额
 *  */
const vpsCalculate = params => axios.post('/vps/calculate',params)

/** VPS申请退款
 *  */
const vpsRefund = params => axios.post('/vps/refund',params)

/** 获取业务产品对应的操作日志
 *  */
const userGet_business_log = params => axios.post('/user/get_business_log',params)

/** 获取工单分类列表
 *  */
const ticketCategoryList = params => axios.get('/ticket/category/list',{params})

/** cdn列表
 *  */
const cdnCDNList = params => axios.get('/cdn/CDN/list',{params})

/** cdn续费
 *  */
const cdnCDNRenewal = params => axios.post('/cdn/CDN/renewal',params)

/** cdn站点列表
 *  */
const cdnSiteList = params => axios.get('/cdn/site/list',{params})

/** cdn添加站点
 *  */
const cdnSiteCreate = params => axios.post('/cdn/site/create',params)

/** cdn删除站点
 *  */
const cdnSiteDelete = params => axios.post('/cdn/site/delete',params)

/** cdn站点详情
 *  */
const cdnSiteDetails = params => axios.get('/cdn/site/details',{params})

export {
    baseUrl,
    webUrl,
    isNewVersion,
    siteInfo,
    logout,
    userStatistics,
    userDomainIndex,
    domainInfo,
    userDomainDnsListRecords,
    userDomainDnsAddRecord,
    userDomainDnsUpdateRecord,
    userDomainDnsDeleteRecord,
    userUserInfo,
    userInfoSave,
    userPasswordReset,
    userUserLoginLog,
    userDomainSubDomainForward,
    domainForwardAdd,
    domainForwardSubDomainList,
    userFinancialChanges,
    paymentGetPaymentList,
    payPaymentRecharge,
    userOrderServerList,
    orderServerDetails,
    orderCloudList,
    orderCloudDetails,
    userPaymentRecharge,
    userServerLists,
    serverDetail,
    domainForwardDeleteSubDomain,
    domainDnsList,
    domainDnsChange,
    userDomainRenewal,
    serverTraffic,
    serverPower,
    serverOslist,
    serverRenewal,
    serverRebuild,
    serverTask,
    serverPassword_reset,
    domainTemplateList,
    domainTemplateAdd,
    domainTemplateDetails,
    domainTemplateEdit,
    domainTemplateDelete,
    serverCancelRebuild,
    serverEdit,
    refundCalculate,
    refundApply,
    refundCancel,
    refundList,
    refundGet,
    sslSslRefund,
    payOrderList,
    payOrderGet,
    payOrderPayAgain,
    DomainOrderList,
    orderDomainDetails,
    SSLList,
    SSLTemplateList,
    SSLTemplateDel,
    SSLTemplateGet,
    SSLTemplateAdd,
    SSLTemplateEdit,
    SSLSslApply,
    SSLSslGet,
    SSLOrderList,
    PayOrderCheck,
    ticketList,
    ticketClose,
    ticketAdd,
    ticketDetails,
    ticketReply,
    financialChangesDetails,
    orderSslDetails,
    affDetails,
    affOrder,
    affWithdrawCommissionList,
    affUserList,
    affWithdraw,
    affCreateInviteCode,
    cloudList,
    cloudNote,
    cloudRenewal,
    cloudDetails,
    cloudPower,
    cloudResetPwd,
    cloudServerVnc,
    cloudRebuild,
    cloudSystemStartRescue,
    cloudSystemStopRescue,
    cloudOsList,
    cloudServerStatus,
    cloudStatistics,
    cloudFlow_data,
    cloudSecurity_groups_rule_list,
    cloudSecurity_group_rule_protocols,
    cloudGet_cron_snap_list,
    cloudAdd_cron_snap,
    cloudDel_cron_snap,
    cloudCreate_security_groups_rule,
    cloudDel_security_groups_rule,
    cloudHostname,
    cloudCalculate,
    cloudRefund,
    userSettingNotification,
    userGet_bind_goole_qr_code,
    userBind,
    userSend_email,
    userVerify_code,
    userEmail_verify_code,
    userCloudGet_filed,
    serverSensitiveInfo,
    serverCalculate,
    serverRefund,
    domainCalculate,
    domainRefund,
    ticketUploadImages,
    userCouponList,
    userClear_google_secret,
    vpsList,
    vpsNote,
    vpsDetails,
    vpsTraffic,
    vpsPower,
    vpsSensitiveInfo,
    vpsOslist,
    vpsRenewal,
    vpsCalculate,
    vpsRefund,
    userGet_business_log,
    ticketCategoryList,
    cdnCDNList,
    cdnCDNRenewal,
    cdnSiteList,
    cdnSiteCreate,
    cdnSiteDelete,
    cdnSiteDetails,
}
